import { useContext } from "react";
import { LenguajeContext } from "../context/lenguaje";

export function useLenguaje() {
  return useContext(LenguajeContext);
}
